
import { Component, Vue } from 'vue-property-decorator'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ReconfigureMailMessage from '@/components/templates/ReconfigureMailMessage.vue'

/**
 * 認証トークンエラーページ
 */
@Component({
  components: {
    LinkBase,
    ReconfigureMailMessage,
  },
})
export default class ReconfigureMailTokenInvalid extends Vue {}
